// ----------------------------------------------------------------------
// 0.  Local theme preview — ?theme=1..6 swaps the mp-theme--* body class
//     so collaborators can flip palettes. The default (mp-theme--purple)
//     is set server-side in common.tpl.
//       1 purple (default)  2 cream   3 blue
//       4 pink              5 peach   6 black
// ----------------------------------------------------------------------
(function () {
    var body = document.body;
    if (!body || !body.classList.contains('theme-meerpaal')) return;
    var match = window.location.search.match(/[?&]theme=(\d+)/);
    if (!match) return;
    var themes = ['purple', 'cream', 'blue', 'pink', 'peach', 'black'];
    var idx = parseInt(match[1], 10) - 1;
    if (idx < 0 || idx >= themes.length) return;
    body.className = body.className.replace(/\bmp-theme--\S+/g, '').trim();
    body.classList.add('mp-theme--' + themes[idx]);
})();

$(function () {
    // ------------------------------------------------------------------
    // 1.  Hamburger drawer — open/close on every viewport (mirrors the
    //     external meerpaal.tc8l.dev "more menu" pattern, where the
    //     hamburger sits in the cream pill and reveals an off-canvas panel).
    // ------------------------------------------------------------------
    var $wrapper      = $('.navbar-wrapper');
    var $navbar       = $wrapper.find('.navbar');
    var $toggleBtn    = $wrapper.find('.navtoggle-button');
    var $toggleIcon   = $toggleBtn.find('i');

    var navActive = false;

    function setIcon(open) {
        // Swap fa-bars <-> fa-xmark while keeping all other classes intact.
        $toggleIcon.toggleClass('fa-bars', !open).toggleClass('fa-xmark', open);
    }

    function openNavbar() {
        if (navActive) return;
        navActive = true;

        $wrapper.addClass('is-open');
        $navbar.addClass('is-open');
        $toggleBtn.addClass('is-open').attr('aria-expanded', 'true');
        $('body').addClass('mobile-menu-open');
        setIcon(true);

        setTimeout(function () { navActive = false; }, 500);
    }

    function closeNavbar() {
        if (navActive) return;
        navActive = true;

        $wrapper.removeClass('is-open');
        $navbar.removeClass('is-open');
        $toggleBtn.removeClass('is-open').attr('aria-expanded', 'false');
        $('body').removeClass('mobile-menu-open');
        setIcon(false);

        setTimeout(function () { navActive = false; }, 500);
    }

    $toggleBtn.attr('aria-expanded', 'false').on('click', function () {
        if ($wrapper.hasClass('is-open')) closeNavbar();
        else openNavbar();
    });

    // ESC closes the menu
    $(document).on('keydown.meerpaal-nav', function (e) {
        if (e.key === 'Escape' && $wrapper.hasClass('is-open')) {
            closeNavbar();
        }
    });

    // Click on darken overlay closes
    $('.navbar-darken').on('click', function () {
        if ($wrapper.hasClass('is-open')) closeNavbar();
    });

    // ------------------------------------------------------------------
    // 2.  Scroll-hide for the upper header chrome — mirrors external
    //     meerpaal.tc8l.dev where the utility ribbon, visual transition
    //     and big M-logo slide away on scroll, leaving only the white
    //     pill nav (Agenda / Theater / Film / …) in view.
    //     See `.meerpaal-header.is-scrolled` rules in _main.scss.
    // ------------------------------------------------------------------
    var $header = $('.meerpaal-header');
    var SCROLL_HIDE_THRESHOLD = 30;
    var scrollTicking = false;

    function syncScrollState() {
        scrollTicking = false;
        var scrolled = window.pageYOffset > SCROLL_HIDE_THRESHOLD;
        $header.toggleClass('is-scrolled', scrolled);
    }

    $(window).on('scroll.meerpaal-header', function () {
        if (scrollTicking) return;
        scrollTicking = true;
        window.requestAnimationFrame(syncScrollState);
    });
    syncScrollState();        // sync once for back-button restored scroll positions

    // ------------------------------------------------------------------
    // 3.  Submenu accordion — mirrors external Meerpaal:
    //     - Mobile drawer (.menu-primary): tapping a parent item with a
    //       submenu (Cursussen / SamenLeven / Praktische info) expands
    //       the submenu inline instead of navigating to the parent page.
    //     - Desktop pill nav (.nav-inline): clicking the same parent
    //       link toggles `.is-expanded` so the submenu stays open after
    //       the click. Hovering still works (pure-CSS).
    //
    //     Users reach the parent page via the first sub-item ("Cursus
    //     overzicht" etc.) which carries the same href.
    // ------------------------------------------------------------------
    $('.menu-primary, .nav-inline').on(
        'click',
        '.has-submenu > a, .has-submenu > .submenu-toggle',
        function (e) {
            e.preventDefault();
            var $li = $(this).closest('.has-submenu');
            var open = !$li.hasClass('is-expanded');
            // In the desktop pill nav close every other expanded submenu so
            // only one submenu is open at a time. Looks across the whole
            // .nav-inline (not just direct siblings) so it works even if a
            // future tpl tweak nests .has-submenu items differently.
            // Mobile drawer keeps multiple open (matches the accordion
            // behaviour external uses).
            if ($li.parent().hasClass('nav-inline')) {
                $('.nav-inline .has-submenu.is-expanded')
                    .not($li)
                    .removeClass('is-expanded');
            }
            $li.toggleClass('is-expanded', open);
            $li.find('> .submenu-toggle')
                .attr('aria-expanded', open ? 'true' : 'false');
        }
    );

    // Hovering a different .has-submenu in the desktop pill nav closes
    // any other click-expanded submenu — keeps a single submenu visible
    // even if the user opened one by click and then mouses to another.
    $('.nav-inline').on('mouseenter', '.has-submenu', function () {
        $('.nav-inline .has-submenu.is-expanded')
            .not(this)
            .removeClass('is-expanded');
    });

    // Click outside the desktop pill nav closes any expanded submenu so
    // the open dropdown doesn't trap users when they click elsewhere.
    $(document).on('click.meerpaal-submenu', function (e) {
        if ($(e.target).closest('.nav-inline .has-submenu').length) return;
        $('.nav-inline .has-submenu.is-expanded').removeClass('is-expanded');
    });

    // ------------------------------------------------------------------
    // 4.  Footer year auto-fill
    // ------------------------------------------------------------------
    var fy = document.getElementById('footer-year');
    if (fy && !fy.textContent.trim()) fy.textContent = (new Date()).getFullYear();
});
